import type { GridColDef } from '@mui/x-data-grid';
import type { IngestedEventSample } from '@vy/types';
import type { ValueOf } from '@vy/utils';
import { vyDate } from '@vy/utils';
import { formatDate } from '../../../../../../utils/date';

export const EVENTS_COLUMNS_KEYS = Object.freeze({
  NAME: 'name',
  TIMESTAMP: 'timestamp',
  REF: 'ref',
  CUSTOMER_ALIAS: 'customerAlias',
  CUSTOMER_NAME: 'customerName',
  AFFECTED_METERS: 'affectedMeters',
});

export type EventsColumnsKey = ValueOf<typeof EVENTS_COLUMNS_KEYS>;

export const EVENTS_TABLE_COLUMNS: GridColDef<IngestedEventSample>[] = [
  {
    field: EVENTS_COLUMNS_KEYS.NAME,
    valueGetter: (_value, row) => row.name,
    headerName: 'Event Name',
    headerAlign: 'left',
    headerClassName: 'pl-10',
    cellClassName: 'pl-0',
    flex: 1,
    renderCell: ({ value }) => <span className="pl-10">{value}</span>,
  },
  {
    field: EVENTS_COLUMNS_KEYS.TIMESTAMP,
    valueGetter: (_value, row) => row.timestamp,
    headerName: 'Timestamp',
    flex: 1,
    renderCell: ({ value }) => <span className="font-sans text-black">{formatDate(vyDate(value))}</span>,
  },
  {
    field: EVENTS_COLUMNS_KEYS.REF,
    valueGetter: (_value, row) => row.ref,
    headerName: 'Event Ref.',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_ALIAS,
    valueGetter: (_value, row) => row.customerAlias,
    headerName: 'Customer ID',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_NAME,
    valueGetter: (_value, row) => row.customerName,
    headerName: 'Customer Name',
    flex: 1,
  },
  {
    field: EVENTS_COLUMNS_KEYS.AFFECTED_METERS,
    valueGetter: (_value, row) => row.affectedMeters,
    headerName: 'Affected Meters',
    flex: 1,
  },
];
